<div>
  <ol class="tab-bars">
    <li *ngFor="let ele of tabItems| slice:0:limitTab" class="tab-bar-item" [attr.id]="'cs-tab-bar-' + ele.headerName + '-id'">
      <a class="tab-item" [class.active]="isActive(ele)" (click)="navigateByUrl(ele)"
         href="javascript:void(0)">{{ele.headerName}}</a>
    </li>
    <li *ngIf="tabItems.length > limitTab" class="tab-bar-item" dropdown>
      <div class="btn-group float-right">
        <a class="btn btn-link dropdown" type="link" id="dropdownMenu" dropdownToggle
           data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          ...
        </a>
        <div class="dropdown-menu dropdown-menu-left" *dropdownMenu>
          <ng-container *ngFor="let ele of tabItems| slice:limitTab">
            <a class="dropdown-item" href="javascript:void(0)" (click)="navigate(ele)" [attr.id]="'cs-tab-bar-' + ele.headerName + '-id'">{{ele.headerName}}</a>
          </ng-container>
        </div>
      </div>
    </li>
  </ol>
</div>
